var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{attrs:{"outlined":""}},[_vm._t("header",function(){return [_c('v-card-title',{staticStyle:{"background-color":"#eeeeee"}},[_vm._v(" "+_vm._s(_vm.header)+" ")])]}),_c('v-divider'),_vm._t("content"),_vm._t("action")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }